// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, InputAdornment } from '@mui/material';

// third-party
import { bindToggle } from 'material-ui-popup-state';

// assets
import { IconAdjustmentsHorizontal, IconSearch, IconX } from '@tabler/icons-react';

import { HeaderAvatarStyle, OutlineInputStyle } from './styles';
import { SearchPopProps } from './types';
import SearchPopOptions from './SearchPopOptions';

interface Props {
    value: string;
    setValue: (value: string) => void;
    popupState: any;
    handleOptions: (val?: boolean) => void;
    handleOptionsCick: (e: any) => void;
    handleEnter: (e: any) => void;
    cleanSearch: () => void;
    searchProps: SearchPopProps;
}

// ==============================|| SEARCH INPUT - MOBILE||============================== //

const MobileSearch = ({ value, setValue, popupState, handleOptions, handleEnter, cleanSearch, searchProps, handleOptionsCick }: Props) => {
    const theme = useTheme();
    return (
        <OutlineInputStyle
            id="input-search-header"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Search Product"
            onKeyDown={handleEnter}
            startAdornment={
                <InputAdornment position="start">
                    <IconSearch stroke={1.5} size="1rem" color={theme.palette.grey[500]} />
                </InputAdornment>
            }
            endAdornment={
                <InputAdornment position="end">
                    <HeaderAvatarStyle variant="rounded" onClick={handleOptionsCick}>
                        <IconAdjustmentsHorizontal stroke={1.5} size="1.3rem" />
                    </HeaderAvatarStyle>
                    <SearchPopOptions {...searchProps} />
                    <Box
                        sx={{ ml: 2 }}
                        onClick={() => {
                            handleOptions(false);
                            cleanSearch();
                        }}
                    >
                        <Avatar
                            variant="rounded"
                            sx={{
                                ...theme.typography.commonAvatar,
                                ...theme.typography.mediumAvatar,
                                background: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.orange.light,
                                color: theme.palette.orange.dark,
                                '&:hover': {
                                    background: theme.palette.orange.dark,
                                    color: theme.palette.orange.light
                                }
                            }}
                            {...bindToggle(popupState)}
                        >
                            <IconX stroke={1.5} size="1.3rem" />
                        </Avatar>
                    </Box>
                </InputAdornment>
            }
            aria-describedby="search-helper-text"
            inputProps={{ 'aria-label': 'weight' }}
        />
    );
};

export default MobileSearch;
